export default "__VITE_ASSET__DmuprlK$__"